import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { RangePicker } from '../components/analytics/AnalyticsShared';
import { OverviewTab } from '../components/analytics/OverviewTab';
import { ListingsTab } from '../components/analytics/ListingsTab';
import { AdsTab } from '../components/analytics/AdsTab';
import { RecommendationsTab } from '../components/analytics/RecommendationsTab';
import { AlertsTab } from '../components/analytics/AlertsTab';
import { ExportTab } from '../components/analytics/ExportTab';
import { BarChart3, List, Target, Bell, Download, Info } from 'lucide-react';

export default function SellerAnalyticsPage() {
  const [range, setRange] = useState('30d');
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Analytics</h1>
              <p className="mt-1 text-sm text-gray-600">
                Track your listing performance, ad campaigns, and customer engagement
              </p>
            </div>
            <RangePicker value={range} onChange={setRange} />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          {/* Tab Navigation */}
          <TabsList className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 w-full">
            <TabsTrigger value="overview" className="gap-2">
              <BarChart3 className="h-4 w-4" />
              <span className="hidden sm:inline">Overview</span>
            </TabsTrigger>
            <TabsTrigger value="listings" className="gap-2">
              <List className="h-4 w-4" />
              <span className="hidden sm:inline">Listings</span>
            </TabsTrigger>
            <TabsTrigger value="ads" className="gap-2">
              <Target className="h-4 w-4" />
              <span className="hidden sm:inline">Ads</span>
            </TabsTrigger>
            <TabsTrigger value="recommendations" className="gap-2">
              <Info className="h-4 w-4" />
              <span className="hidden sm:inline">Recommendations</span>
            </TabsTrigger>
            <TabsTrigger value="alerts" className="gap-2">
              <Bell className="h-4 w-4" />
              <span className="hidden sm:inline">Alerts</span>
            </TabsTrigger>
            <TabsTrigger value="export" className="gap-2">
              <Download className="h-4 w-4" />
              <span className="hidden sm:inline">Export</span>
            </TabsTrigger>
          </TabsList>

          {/* Tab Content */}
          <TabsContent value="overview">
            <OverviewTab range={range} />
          </TabsContent>

          <TabsContent value="listings">
            <ListingsTab range={range} />
          </TabsContent>

          <TabsContent value="ads">
            <AdsTab range={range} />
          </TabsContent>

          <TabsContent value="recommendations">
            <RecommendationsTab range={range} />
          </TabsContent>

          <TabsContent value="alerts">
            <AlertsTab range={range} />
          </TabsContent>

          <TabsContent value="export">
            <ExportTab range={range} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
